/**
 * Error messages for payment flows
 * Centralizes all error messages for easier maintenance and localization
 */

const PAYMENT_ERROR_MESSAGES = {
  // General errors
  GENERIC_ERROR: 'Oops, something went wrong. Refresh the page and try again.',
  
  // Token payment specific errors
  INVALID_PAYMENT_METHOD: 'Failed to retrieve associated payment method.',
  ENCRYPTION_KEY_FETCH_FAILED: 'Failed to fetch or use encryption key',
  ENCRYPTION_KEY_INVALID: 'Invalid encryption key received from server',
  ENCRYPTION_FAILED: 'Failed to encrypt payment data',
  PAYMENT_DATA_PROCESSING_ERROR: 'Error processing payment data. Refresh the page and try again.',
  
  // User-facing messages
  USER_GENERIC_ERROR: 'Oops, something went wrong. Refresh the page and try again.',
  USER_PAYMENT_PROCESSING_ERROR: 'Unable to process payment. Please try again.',
};

module.exports = {
  PAYMENT_ERROR_MESSAGES,
};